module.exports = __webpack_public_path__ + "static/media/copyIcon.f8bae669.svg";